import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class BuyModal extends kr.Component {
    init() {
        this.cartAdded = false;
        this.ajax_url = window.ajax_url;
        this.$ = window.jQuery;
        this.inited = false;
        this.formatter = new Intl.NumberFormat(window.wc_language.replace('_', '-'), {
            style: 'currency',
            currency: window.wc_currency,
            style: 'decimal',
            minimumFractionDigits: 2
        });

        this.dom.$window.addEventListener('buymodal--init', () => {
            if (!this.inited) {
                this.bind();
                this.inited = true;
            }
        });
        this.dom.$window.addEventListener('buymodal--reload', () => {
            this.cartAdded = false;
        });
    }

    bind()
    {
        this.on('click', '.buymodal .js-close', () => {
            HTMLClass.removeClass(this.app.dom.$body, 'buymodal--opened');
        })

        this.on('click', '.buymodal .js-addToCart', async (target, event) => {
            event.preventDefault();
            if (this.cartAdded) {
                window.location.href = window.wc_cart_url;
            }
            this.loading = true;
            const text = target.innerHTML;
            target.innerHTML = '...';
            target.setAttribute('disabled', 'disabled');
            await this._addToCart();
            target.removeAttribute('disabled');
            this.loading = false;

            if (this.cartAdded) {
                target.innerHTML = window.wc_add_to_cart_params.i18n_view_cart;
                this.$element.querySelector('.buymodal .buymodal__footer__subtotal').style.display="none";
            }
        });

        this._bindQuantity();
    }

    async _addToCart()
    {
        const inputs = this.$element.querySelectorAll('.buymodal input[name="quantity"]');
        const request = {
            action: 'wcAddToCart',
            products: []
        }

        for (let i in inputs) {
            if (!inputs.hasOwnProperty(i)) {
                continue;
            }
            request.products.push({
                product_id: inputs[i].getAttribute('data-id'),
                quantity: inputs[i].value
            });
        }
        const response = await this.$.post(this.ajax_url, request).then();
        const result = JSON.parse(response);
        const el = document.createElement('div');
        HTMLClass.addClass(el, 'buymodal__product__success');
        let html = '';
        if (result.success) {
            html += `<div class="buymodal__product__icon">${result.icon}</div>`;
        }
        html += `<div class="buymodal__product__title"><strong>${result.message}</strong></div>`;
        el.innerHTML = html;
        this.$element.querySelector('.buymodal .buymodal__content').innerHTML = '';
        this.$element.querySelector('.buymodal .buymodal__content').append(el);
        if (result.success == true) {
            this.cartAdded = true;

            this._updateCart();
            
        }
    }

    _calcPrice()
    {
        const inputs = this.$element.querySelectorAll('.buymodal input[name="quantity"]');
        let summary = 0;

        for (let i in inputs) {
            if (!inputs.hasOwnProperty(i)) {
                continue;
            }
            const input = inputs[i];
            const quantity = input.value;
            const toUpdate = input.getAttribute('data-change');
            const $parent = this.$element.querySelector(`.buymodal ${toUpdate}`);
            const $el = this.$element.querySelector(`.buymodal ${toUpdate} .js-price`);
            let price = $el.getAttribute('data-price');
            price = price*quantity;
            summary+=price;
            if ($parent.getAttribute('data-prevent-change') == 1) {
                continue;
            }
            $el.innerHTML = this.formatter.format(price);
        }

        this.$element.querySelector('.buymodal .js-subtotal-price .js-price').innerHTML = this.formatter.format(summary);

    }

    async _updateCart()
    {
        let url = window.woocommerce_params.wc_ajax_url;
        url = url.replace("%%endpoint%%", "get_refreshed_fragments");

		const result = await this.$.post(url).then();
        if ( result.fragments ) {
            this.$.each(result.fragments, (key, value) => {
                this.$(key).replaceWith(value);
            });
            this.$(document.body).trigger( 'wc_fragment_refresh' );
        }
    }

    _bindQuantity()
    {
        this.on('click', '.buymodal .js-productQuantity .js-down', (target, event) => {
            event.preventDefault();
            
            const input = target.parentNode.querySelector('.buymodal__quantity__input');
            const isProduct = HTMLClass.hasClass(input, 'js-product');
            let min = 1;
            const inputMin = input.getAttribute('min');

            if (isFinite(inputMin)) {
                min = inputMin;
            }

            if (input.value == min) {
                return false;
            }

            input.value = parseInt(input.value) - 1;
            this._calcPrice();
        });
        
        this.on('click', '.buymodal .js-productQuantity .js-up', (target, event) => {
            event.preventDefault();
            const input = target.parentNode.querySelector('.buymodal__quantity__input');
            input.value = parseInt(input.value) + 1;
            this._calcPrice();
        });

        this.on('change', '.buymodal input[name="quantity"]', (target, event) => {
            event.preventDefault();
            this._calcPrice();
        });
    }

    
}

kr.registerComponent('.web__root', {
    component: BuyModal
});
